import { useState } from 'react';

import { OverlayContext } from './overlay-context';

import styles from './overlay.module.scss';

export const OverlayContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [ref, setRef] = useState<HTMLDivElement | null>(null);

  return (
    <OverlayContext.Provider value={{ overlayContainer: ref }}>
      {children}
      <div ref={setRef} className={styles.portal} />
    </OverlayContext.Provider>
  );
};
